import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
  RiskAnalysesTile: () => import("./components/tiles/RiskAnalysesTile.vue"),
  RiskAnalysesMap: () => import("./components/tiles/RiskAnalysesMap.vue"),
  RiskAnalysesTileSummary: () => import("./components/tiles/RiskAnalysesTileSummary.vue"),
  RiskAnalysesMapSummary: () => import("./components/tiles/RiskAnalysesMapSummary.vue"),
  RiskAnalysisManagerTile: () => import("./components/tiles/RiskAnalysisManagerTile.vue"),
  RiskAnalysisManagerTileContainer: () => import("./components/RiskAnalysisManagerTileContainer.vue"),
};

export default globals;
